export default __webpack_public_path__ + "static/media/img_star_dark.71fe84ab.svg";